import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/ai-requests/{creatorId}/{questionnaireTemplateSlug}']['GET'];
type Input = ThisApi['params'];

const getAiRequests = async ({ creatorId, questionnaireTemplateSlug }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/ai-requests/{creatorId}/{questionnaireTemplateSlug}', {
    creatorId,
    questionnaireTemplateSlug,
  });
  const data = await formsBackendClient.get(path);
  return data.data;
};

export default getAiRequests;
